import Radium from "radium";
import { useEffect, useState } from 'react';
import SeoHelmets from '../SeoOptimazation/SeoHelmets';
import { useParams } from 'react-router-dom';
import userImage from "../../Image/user.png";
import Content from '../AllPageContent/AllPageContent';
import ButtonPage from '../ButtonPage/ButtonPage';
import Buttontabs from '../Buttontabs/Buttontabs';
import CurrentAffair from '../CurrentAffair/CurrentAffair';
import { fetchblogdetail } from '../DynamicCourse/api';
import Likeshare from '../LikeandShareCompoent/Likeshare';
import CivilTopSection from '../ReusableComponent/CIVIL/CivilTopSection/CivilTopSection';
import "../ReusableComponent/CIVIL/CivilTopSection/CivilTopSection.css";

function DynamicToday() {
    const { todayurl } = useParams();
    const [newData, setNewData] = useState(null);
    const Buttonname = "Singlebutton";
    const componentName = "Blog";
    const [contentToShow, setContentToShow] = useState('In News');

    useEffect(() => {
        // if()
        const fetchData = async () => {
            try {
                // const response = await fetch(`${BASE_URL}/blog/${todayurl}`);
                // const data = await response.json();
                const data = await fetchblogdetail(todayurl);
                setNewData(data[0]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [todayurl]);
    if (!newData) {
        return <div>Loading...</div>
    }
    const data = {
        academyName: newData.Title,
        userImage: userImage,
        userName: 'INSIGHT IAS',
        Image: newData.Image
    };

    const paragraphs = newData.Description
    const noteurl = newData.NotePDF

    const blogStyle = {
        before: {
            content: '""',
            width: "100%",
            backgroundImage: `url(${newData.Image})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "top",
            opacity: "0.5",
            position: "absolute",
            filter: "blur(50px)",
            zIndex: "1"
        }
    }
    return (
        <>
            <SeoHelmets 
                title={newData.MetaTitle} 
                description={newData.MetaDescription}
            />
            {/* Civil Cop Section Start */}
            <section className={`${todayurl} dynamic-blog`}>
                <section style={blogStyle.before} className='dynamic-blog-before' />
                {/* Civil Top Section Start */}
                <CivilTopSection
                    academyName1={data.academyName}
                    userImage={data.userImage}
                    userName={data.userName}
                    Image={data.Image}
                />
                {/* Civil Top Section End */}
            </section>
            <div className='Civil-section'>
                <div className='civil-row'>
                    <div className='col-lg-8 col-md-12 col-sm-12 me-2'>
                        <div className='BlogPage-box2 dynamicPage-box2 d-flex flex-wrap align-items-center justify-content-between'>
                            <div>
                                <Buttontabs componentName={componentName} setContentToShow={setContentToShow} />
                            </div>
                            <div>
                                <Likeshare Like={newData.LikeCount + newData.PreLikes} Sn={newData.Sn} view={newData.ViewCount + newData.preViews} />
                            </div>
                        </div>
                        <Content paragraphs={paragraphs} />
                        <ButtonPage Pagename={Buttonname} noteurl={noteurl} />
                        {/* <Tag /> */}
                    </div>
                    {/* Civil right Section Start */}
                    <div className='col-lg-4 col-md-12 col-sm-12'>
                        <div className='card p-2'>
                            <CurrentAffair componentName={componentName} />
                        </div>
                    </div>
                    {/* Civil right Section End */}
                </div>
            </div>
            {/* Civil Cop Section End */}
        </>
    )
}

export default Radium(DynamicToday);